import { render, staticRenderFns } from "./Integracoes.vue?vue&type=template&id=08c71949&scoped=true"
import script from "./Integracoes.vue?vue&type=script&lang=js"
export * from "./Integracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c71949",
  null
  
)

export default component.exports